<template>
  <div>
    <div>
      <ElXlsx @upData="upData" />
    </div>
    <el-table :data="tableData" border style="width: 100%" v-if="this.labels.length">
      <el-table-column prop="name" label="项目">
      </el-table-column>
      <el-table-column prop="firstYear" :label="this.labels[0]">
      </el-table-column>
      <el-table-column prop="secondYear" :label="this.labels[1]">
      </el-table-column>
      <el-table-column prop="thirdYear" :label="this.labels[2]">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import ElXlsx from '../../components/ElXlsx.vue'
  export default {
    components: {
      ElXlsx
    },
    inject: ['reload'],
    data() {
      return {
        tableData: [],
        items: ['name', 'firstYear', 'secondYear', 'thirdYear'],
        labels: []
      }
    },
    mounted() {
      this.$axios.post('/annual_general/findList').then(res => {
        this.tableData = res.data.data.slice(0, 6)
        let obj = res.data.data[6]
        this.labels = [obj.firstYear, obj.secondYear, obj.thirdYear,]
      })
    },
    methods: {
      upData(e) {
        let dataArr = this.$replaceString(e, this.items)
        this.$axios.post('/annual_general/save', dataArr).then(res => {
          this.$message({
            message: '导入成功。',
            type: 'success'
          })
          this.reload()
        })
      },
    }
  }
</script>

<style scoped>
  .el-table {
    margin-top: 20px;
  }
</style>